import useKioskReset from "@/Pages/Auth/Maps/useKioskReset";
import usePriorityModal from "@/shared/atoms/usePriorityModal";
import { useIdleTimer } from "@/shared/hooks/useIdleHook";
import { useRef } from "react";
import { useHistory, useLocation } from "react-router-dom";

const IDLE_TIMEOUT = 45_000; // 45 sec
const CONFIRM_TIMEOUT = 45_000;

const KioskGlobal = () => {
  const { pathname } = useLocation();

  const isKioskRoute = pathname.includes("/kiosk") && pathname !== "/kiosk";

  return <>{isKioskRoute ? <Global /> : ""}</>;
};

const Global = () => {
  const reset = useKioskReset();
  const [modal, setModal] = usePriorityModal();
  const history = useHistory();
  const confirmTimer = useRef<ReturnType<typeof setTimeout> | null>(null);

  const resetKiosk = () => {
    reset();
    history.push("/kiosk");
  };

  const handleStillHere = () => {
    setModal({ priorityModal: "", meta: {} });
    if (confirmTimer.current) clearTimeout(confirmTimer.current);
    resetIdleTimer();
  };

  const onIdle = () => {
    setModal((c) =>
      c.priorityModal === "pendingPayment"
        ? c
        : {
            priorityModal: "kioskIdle",
            meta: {
              onConfirm: handleStillHere,
            },
          }
    );

    confirmTimer.current = setTimeout(() => {
      resetKiosk();
    }, CONFIRM_TIMEOUT);
  };

  const resetIdleTimer = useIdleTimer(onIdle, IDLE_TIMEOUT);

  return <></>;
};

export default KioskGlobal;
